import { getSupabase, isSupabaseConfigured } from '../lib/supabase';
import { assertOnlineOrThrow } from '../lib/offlineGuard';

/**
 * Record search to popular_searches and (if logged in) search_history. Safe no-op if RPC missing.
 * @param {string} q
 */
export async function recordSearchQueryServer(q) {
  const term = String(q || '').trim();
  if (term.length < 1) return;
  if (!isSupabaseConfigured) return;
  const sb = getSupabase();
  if (!sb) return;
  try {
    assertOnlineOrThrow();
  } catch {
    return;
  }
  try {
    const { error } = await sb.rpc('record_search_query', { p_query: term });
    if (error) {
      /* migration not applied or policy */
    }
  } catch {
    /* offline */
  }
}

/** @param {number} [limit] */
export async function fetchPopularSearchQueries(limit = 12) {
  if (!isSupabaseConfigured) return [];
  const sb = getSupabase();
  if (!sb) return [];
  try {
    assertOnlineOrThrow();
  } catch {
    return [];
  }
  // Prod columns: keyword + count (not `query`). Alias `count` → hit_count for PostgREST clarity.
  const { data, error } = await sb
    .from('popular_searches')
    .select('keyword, hit_count:count')
    .order('count', { ascending: false })
    .limit(limit);
  if (error) return [];
  return (data || [])
    .map((r) => r.keyword)
    .filter((x) => typeof x === 'string' && x.length > 0);
}
